import { render, staticRenderFns } from "./Portfolios.vue?vue&type=template&id=817fbe92&scoped=true&"
import script from "./Portfolios.vue?vue&type=script&setup=true&lang=js&"
export * from "./Portfolios.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817fbe92",
  null
  
)

export default component.exports